(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-policy"]) return;
  try {
    
  (() => {
    /* Full-line title: "1. Return Eligibility:" or "1) Shipping" */
    const SECTION_LINE_RE = /^\s*(\d+)[.)]\s*(.+?)\s*:?\s*$/;
    /* Title at start of a longer paragraph: "1. Title: body…" */
    const SECTION_INLINE_RE = /^\s*(\d+)[.)]\s*([^:\n]{1,120}?)\s*:/;
    const HEADING_TAGS = new Set(['H1', 'H2', 'H3', 'H4']);
    /* Shopify / pasted-editor wrappers — unwrap so numbered sections are visible */
    const UNWRAP_TAGS = new Set(['DIV', 'SECTION', 'ARTICLE', 'MAIN', 'ASIDE']);

    class OmPolicyDocument extends HTMLElement {
      connectedCallback() {
        this.source = this.querySelector('[data-om-policy-source]');
        this.sectionsEl = this.querySelector('[data-om-policy-sections]');
        this.toc = this.querySelector('[data-om-policy-toc]');
        this.tocList = this.querySelector('[data-om-policy-toc-list]');
        this.introSlot = this.closest('section')?.querySelector('[data-om-policy-intro]');
        this.showToc = this.dataset.showToc === 'true';
        this.cardScheme = this.dataset.cardScheme || 'scheme-1';
        this.bp = parseFloat(this.dataset.breakpoint) || 1024;

        if (!this.source || !this.sectionsEl) return;

        this.build();
        this._onResize = () => this.syncAccordionMode();
        window.addEventListener('resize', this._onResize);
        this.syncAccordionMode();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this._onResize);
      }

      isDesktop() {
        return window.matchMedia(`(min-width: ${this.bp}px)`).matches;
      }

      normalizeText(text) {
        return (text || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
      }

      matchSectionMeta(text) {
        const trimmed = this.normalizeText(text);
        if (!trimmed) return null;
        let match = trimmed.match(SECTION_LINE_RE);
        if (match) {
          return { number: match[1], title: match[2].replace(/:$/, '').trim() };
        }
        match = trimmed.match(SECTION_INLINE_RE);
        if (match) {
          return { number: match[1], title: match[2].trim() };
        }
        return null;
      }

      /**
       * Flatten nested editor/chat wrappers so top-level blocks are P/UL/H*
       * (Privacy/Terms/Shipping were pasted with nested DIV chrome).
       */
      collectBlocks(root) {
        const out = [];
        const visit = (parent) => {
          for (const n of [...parent.childNodes]) {
            if (n.nodeType === Node.TEXT_NODE) {
              if (this.normalizeText(n.textContent)) out.push(n);
              continue;
            }
            if (!(n instanceof HTMLElement)) continue;
            const tag = n.tagName;
            if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT' || tag === 'SVG') continue;
            if (UNWRAP_TAGS.has(tag)) {
              visit(n);
              continue;
            }
            out.push(n);
          }
        };
        visit(root);
        return out;
      }

      leadingStrong(node) {
        if (!(node instanceof HTMLElement) || node.tagName !== 'P') return null;
        const strong = node.querySelector(':scope > strong, :scope > b');
        if (!strong) return null;
        /* Only treat as a section heading when strong is the first meaningful child */
        for (const child of node.childNodes) {
          if (child === strong) return strong;
          if (child.nodeType === Node.TEXT_NODE && this.normalizeText(child.textContent)) return null;
          if (child.nodeType === Node.ELEMENT_NODE && child !== strong) return null;
        }
        return strong;
      }

      parseTitle(node) {
        const strong = this.leadingStrong(node);
        if (strong) {
          const meta = this.matchSectionMeta(strong.textContent || '');
          if (meta) return meta;
        }
        const meta = this.matchSectionMeta(node.textContent || '');
        if (meta) return meta;
        const text = this.normalizeText(node.textContent || '');
        return { number: '', title: text.replace(/:$/, '').trim() };
      }

      startsSection(node) {
        if (!(node instanceof HTMLElement)) return false;
        if (HEADING_TAGS.has(node.tagName)) {
          return !!this.matchSectionMeta(node.textContent || '');
        }
        if (node.tagName === 'STRONG' || node.tagName === 'B') {
          return !!this.matchSectionMeta(node.textContent || '');
        }
        if (node.tagName === 'P') {
          const strong = this.leadingStrong(node);
          if (strong && this.matchSectionMeta(strong.textContent || '')) return true;
          return !!this.matchSectionMeta(node.textContent || '');
        }
        return false;
      }

      /**
       * When a paragraph is "1. Title: body copy…" in one node, split the
       * heading from the remainder so the body lands in the card.
       */
      extractInlineRemainder(node, meta) {
        if (!(node instanceof HTMLElement) || node.tagName !== 'P') return null;
        const full = this.normalizeText(node.textContent || '');
        if (!meta.number || !meta.title) return null;
        if (SECTION_LINE_RE.test(full)) return null;

        const strong = this.leadingStrong(node);
        if (strong && this.matchSectionMeta(strong.textContent || '')) {
          const clone = node.cloneNode(true);
          const headingEl = clone.querySelector(':scope > strong, :scope > b');
          headingEl?.remove();
          if (clone.firstChild?.nodeType === Node.TEXT_NODE) {
            clone.firstChild.textContent = (clone.firstChild.textContent || '').replace(/^[\s:–—-]+/, '');
          }
          if (this.normalizeText(clone.textContent || '')) return clone;
          return null;
        }

        const prefixRe = new RegExp(
          `^\\s*${meta.number}[.)]\\s*${meta.title.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\s*:?\\s*`,
          'i'
        );
        const remainderText = full.replace(prefixRe, '').trim();
        if (!remainderText || remainderText === full) return null;

        const p = document.createElement('p');
        p.textContent = remainderText;
        return p;
      }

      build() {
        const children = this.collectBlocks(this.source);

        if (!children.length) return;

        const preamble = [];
        const sections = [];
        let current = null;

        for (const node of children) {
          if (!(node instanceof HTMLElement)) {
            if (current) current.nodes.push(node);
            else preamble.push(node);
            continue;
          }

          if (this.startsSection(node)) {
            const meta = this.parseTitle(node);
            current = { ...meta, nodes: [] };
            const remainder = this.extractInlineRemainder(node, meta);
            if (remainder) current.nodes.push(remainder);
            sections.push(current);
            continue;
          }
          if (current) {
            current.nodes.push(node);
          } else {
            preamble.push(node);
          }
        }

        if (!sections.length) {
          /* Keep source visible as readable fallback */
          return;
        }

        /* Optional auto-intro from content before the first numbered section,
           only when merchant did not set an intro setting. */
        const hasMerchantIntro = this.closest('section')?.querySelector('.om-policy__intro:not(.om-policy__intro--auto)');
        if (this.introSlot && !hasMerchantIntro && preamble.length) {
          this.introSlot.innerHTML = '';
          preamble.forEach((n) => this.introSlot.appendChild(n.cloneNode(true)));
          this.introSlot.hidden = false;
        }

        this.source.hidden = true;
        this.sectionsEl.querySelectorAll('[data-om-policy-card]').forEach((el) => el.remove());

        if (this.tocList) this.tocList.innerHTML = '';

        const cardClass = 'om-policy__card';

        sections.forEach((section, index) => {
          const num = section.number || String(index + 1);
          const id = `om-policy-section-${num}-${index}`;

          const details = document.createElement('details');
          details.className = cardClass;
          details.dataset.omPolicyCard = '';
          details.id = id;

          const summary = document.createElement('summary');
          summary.className = 'om-policy__card-summary';

          const titleEl = document.createElement('span');
          titleEl.className = 'om-policy__card-title';
          titleEl.textContent = `${num}. ${section.title}`;

          const chevron = document.createElement('span');
          chevron.className = 'om-policy__card-chevron';
          chevron.setAttribute('aria-hidden', 'true');
          chevron.innerHTML =
            '<svg viewBox="0 0 20 20" width="18" height="18" fill="none" focusable="false"><path d="M5 7.5 10 12.5 15 7.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

          summary.append(titleEl, chevron);

          const body = document.createElement('div');
          body.className = 'om-policy__card-body';
          section.nodes.forEach((n) => body.appendChild(n.cloneNode(true)));

          details.append(summary, body);
          this.sectionsEl.appendChild(details);

          if (this.tocList) {
            const li = document.createElement('li');
            const a = document.createElement('a');
            a.className = 'om-policy__toc-link';
            a.href = `#${id}`;
            a.textContent = `${num}. ${section.title}`;
            a.addEventListener('click', (event) => {
              event.preventDefault();
              event.stopPropagation();
              const target = this.sectionsEl.querySelector(`#${CSS.escape(id)}`);
              if (!target) return;
              if (!this.isDesktop()) target.open = true;
              this.setActiveToc(a);
              this.scrollToSection(target);
              history.replaceState(null, '', `#${id}`);
            });
            li.appendChild(a);
            this.tocList.appendChild(li);
          }
        });

        if (this.toc && this.showToc && this.tocList?.children.length) {
          this.toc.hidden = false;
          this.setupTocObserver();
        }

        this.syncAccordionMode();

        if (location.hash) {
          const hashId = location.hash.slice(1);
          const deepTarget = this.sectionsEl.querySelector(`#${CSS.escape(hashId)}`);
          if (deepTarget) {
            if (!this.isDesktop()) deepTarget.open = true;
            requestAnimationFrame(() => this.scrollToSection(deepTarget, true));
          }
        }
      }

      headerOffset() {
        const raw =
          getComputedStyle(document.body).getPropertyValue('--header-height') ||
          getComputedStyle(document.documentElement).getPropertyValue('--header-height') ||
          '0';
        const gapRaw =
          getComputedStyle(this).getPropertyValue('--om-policy-toc-gap') ||
          getComputedStyle(this.closest('[class*="om-policy-"]') || document.body).getPropertyValue(
            '--om-policy-toc-gap'
          ) ||
          '0';
        return (parseFloat(raw) || 0) + (parseFloat(gapRaw) || 0);
      }

      scrollToSection(target, instant = false) {
        if (!target) return;
        const prefersReduced =
          instant ||
          (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
        const top = target.getBoundingClientRect().top + window.scrollY - this.headerOffset();

        this._tocScrollLock = true;
        if (this._tocScrollUnlockTimer) window.clearTimeout(this._tocScrollUnlockTimer);

        window.scrollTo({
          top: Math.max(0, top),
          behavior: prefersReduced ? 'auto' : 'smooth',
        });

        this._tocScrollUnlockTimer = window.setTimeout(
          () => {
            this._tocScrollLock = false;
          },
          prefersReduced ? 50 : 900
        );
      }

      syncAccordionMode() {
        const desktop = this.isDesktop();
        this.querySelectorAll('[data-om-policy-card]').forEach((card) => {
          if (desktop) {
            card.open = true;
          } else if (!card.dataset.userToggled) {
            card.open = false;
          }
        });

        if (!desktop) {
          this.querySelectorAll('[data-om-policy-card]').forEach((card) => {
            card.addEventListener(
              'toggle',
              () => {
                card.dataset.userToggled = 'true';
              },
              { once: true }
            );
          });
        }
      }

      setActiveToc(activeLink) {
        this.tocList?.querySelectorAll('.om-policy__toc-link').forEach((link) => {
          link.setAttribute('aria-current', link === activeLink ? 'true' : 'false');
        });
      }

      setupTocObserver() {
        if (!this.tocList || !('IntersectionObserver' in window)) return;
        if (this._tocObserver) this._tocObserver.disconnect();

        const links = [...this.tocList.querySelectorAll('.om-policy__toc-link')];
        const cards = [...this.querySelectorAll('[data-om-policy-card]')];
        if (!cards.length) return;

        this._tocObserver = new IntersectionObserver(
          (entries) => {
            if (this._tocScrollLock) return;
            const visible = entries
              .filter((e) => e.isIntersecting)
              .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
            if (!visible) return;
            const id = visible.target.id;
            const link = links.find((a) => a.getAttribute('href') === `#${id}`);
            if (link) this.setActiveToc(link);
          },
          { rootMargin: '-25% 0px -55% 0px', threshold: [0.05, 0.2, 0.4, 0.6] }
        );

        cards.forEach((card) => this._tocObserver.observe(card));
        if (links[0]) this.setActiveToc(links[0]);
      }
    }

    if (!customElements.get('om-policy-document')) {
      customElements.define('om-policy-document', OmPolicyDocument);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
